@for (entity of entitiesSg(); track entity.id) {
  @let options = optionsFor(entity.id)();
  @let values = pluginSg().selectors.selectionFor(entity.id).asSignal();

  <atn-ds-select-multiple
    [config]="{
      overlay: {
        minSearchCharacters: 1,
        hasSearch: true,
      },
    }"
    [value]="values"
    [error]="options.error"
    [items]="options.items"
    [label]="labelSg() ?? entity.name"
    [loading]="options.loading"
    [disabled]="options.loading"
    (refetch)="refetch(entity.id)"
    (valueChange)="selectionChanged(entity.id, $event)"
  />
}
